import type { RouteObject } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="text-6xl font-heading font-bold text-primary-500">404</h1>
      <p className="mt-4 text-xl text-foreground-700 font-body">页面未找到</p>
      <p className="mt-2 text-foreground-500 font-body">你访问的页面可能已被移除或地址有误</p>
      <Link
        to="/"
        className="mt-6 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-body text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
      >
        返回首页
      </Link>
    </div>
  );
}